module.exports = __webpack_public_path__ + "img/memry_new.dd56189b.png";